import { createSlice } from "@reduxjs/toolkit";

export const homeSlice = createSlice({
  name: "home",
  initialState: {
    privileges: {},
    role: "",
    userDetails: {},
    entityDetails: {},
    navbarshow: false,
    deviceUUID: "",
    pageData: {
      reduxPage: 1,
      numberOfList: 1,
      currentTab: 0
    },
    commonLoader: false,
    profileData: {}
  },

  reducers: {
    updatePrevilegesState: (state = homeSlice?.initialState, action) => {
      state.privileges = action.payload;
    },
    updateUserDetails: (state = homeSlice?.initialState, action) => {
      state.userDetails = action.payload;
    },
    clearUserDetails: (state = homeSlice?.initialState) => {
      state.userDetails = {}; // Clear user details
    },
    updateRole: (state = homeSlice?.initialState, action) => {
      
      state.role = action.payload;
    },
    updateEntityDetails: (state, action) => {
      state.entityDetails = action.payload;
    },
    setShowNavbar: (state = homeSlice?.initialState, action) => {
      state.navbarshow = action.payload;
    },
    updateCommonLoader: (state = homeSlice?.initialState, action) => {
      state.commonLoader = action.payload;
    },
    updateDeviceUUID: (state = homeSlice?.initialState, action) => {
      state.deviceUUID = action.payload;
    },
    updatePageData: (state = homeSlice?.initialState, action) => {
      
      state.pageData = action.payload;
    },
    updateProfileData: (state = homeSlice?.initialState, action) => {
      state.profileData = action.payload;
    },
    resetState: () => {
      return homeSlice.getInitialState();
    },
  },
});
export const {
  updatePrevilegesState,
  updateRole,
  updateUserDetails,
  updateEntityDetails,
  setShowNavbar,
  updateDeviceUUID,
  updatePageData,
  updateCommonLoader,
  updateProfileData,
  clearUserDetails, resetState
} = homeSlice.actions;
export default homeSlice.reducer;
